import { useRecoilValue } from 'recoil';
import { DependencyContainer } from '../../../DependencyContainer';
import { useFetch } from 'plume-web-utils';
import { activePartnerAtom } from '../../../state';
import { UseFetchCacheKeys } from '../../../cacheConfig';

const { outreachService } = new DependencyContainer();

const useEmails = () => {
  const activePartner = useRecoilValue(activePartnerAtom);

  return useFetch(
    async () => {
      const data = await outreachService.getEmails(activePartner?.id || '');
      return data.sort((a, b) => a.email.localeCompare(b.email));
    },
    {
      dependencies: [activePartner?.id],
      skip: !activePartner?.id,
      cacheKey: UseFetchCacheKeys.Emails,
    },
  );
};
export default useEmails;
